<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" lg="10" offset-lg="1">
        <h2 class="title mb-3">レギュレーションチェック一覧</h2>
        <permission-guard situation="regulation_check_management">
          <v-btn color="primary" dark tile @click="newRegulationCheck">
            新規作成
          </v-btn>
          <v-btn color="teal" dark tile @click="newRegulationCheckFromTemplate">
            テンプレートから作成
          </v-btn>
          <v-simple-table fixed-header>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" style="width: 25%">ID</th>
                  <th class="text-left" style="width: 50%">
                    レギュレーションチェック名
                  </th>
                  <th style="width: 8%" />
                  <th style="width: 8%" />
                  <th style="width: 8%" />
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="regulationBundler in regulationBundlers"
                  :key="regulationBundler.id"
                >
                  <td class="text-left">
                    {{ regulationBundler.id }}
                  </td>
                  <td class="text-left">
                    {{ regulationBundler.name }}
                  </td>
                  <td class="text-center">
                    <v-btn
                      tile
                      outlined
                      small
                      color="primary"
                      @click="editRegulationCheck(regulationBundler)"
                    >
                      <v-icon left small> mdi-pencil </v-icon>
                      編集
                    </v-btn>
                  </td>
                  <td class="text-center">
                    <v-btn
                      tile
                      outlined
                      small
                      color="success"
                      @click="copyRegulationCheck(regulationBundler)"
                    >
                      <v-icon left small> mdi-content-copy </v-icon>
                      コピーを作成する
                    </v-btn>
                  </td>
                  <td class="text-center">
                    <v-btn
                      tile
                      outlined
                      small
                      color="error"
                      @click="deleteRegulationCheck(regulationBundler.id)"
                    >
                      <v-icon left small> mdi-delete </v-icon>
                      削除
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </permission-guard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import { deserialize } from 'deserialize-json-api'
import PermissionGuard from '@/components/commons/PermissionGuard'
import headUtilsMixin from '@/mixins/head_utils'

export default {
  components: { PermissionGuard },
  mixins: [headUtilsMixin],
  data: () => {
    return {
      pageTitle: 'レギュレーションチェック一覧',
      regulationBundlers: [],
      regulationItems: [],
      destroyRegulationItems: [],
      editingRegulationBundler: {},
      regulationTemplateItems: [],
      regulationTemplateName: null
    }
  },
  mounted: function () {
    this.fetchRegulationBundlers()
  },
  methods: {
    fetchRegulationBundlers () {
      axios.get('/api/regulation_bundlers').then(
        ({ data }) => {
          this.regulationBundlers = deserialize(data).data
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.errors.toString()
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    },
    editRegulationCheck (regulationBundler) {
      this.$router.push({
        name: 'adminRegulationCheckEdit',
        params: { id: regulationBundler.id }
      })
    },
    referRegulationItems () {
      return axios
        .get(
          `/api/regulation_bundlers/${this.editingRegulationBundler.id}/edit`
        )
        .then(({ data }) => {
          if (deserialize(data).data.regulationItems) {
            let tmpArr = deserialize(data).data.regulationItems
            tmpArr.sort(function (a, b) {
              if (a.order < b.order) return -1
              if (a.order > b.order) return 1
            })
            this.regulationItems = tmpArr
          } else {
            this.regulationItems = []
          }
        })
    },
    newRegulationCheck () {
      this.regulationItems = []
      this.editingRegulationBundler = {}
      this.$router.push({
        name: 'adminRegulationCheckNew'
      })
    },
    pushRegulationBundler (bundler) {
      this.regulationBundlers.push(bundler)
    },
    async newRegulationCheckFromTemplate () {
      this.regulationItem = []
      this.editingRegulationBundler = {}
      if (
        !this.regulationTemplateName &&
        !this.regulationTemplateItems.length
      ) {
        await this.fetchRegulationTemplate()
      } else {
        this.assignTemplateToEditingRegulation()
      }
      this.$router.push({
        name: 'adminRegulationCheckNew',
        query: {
          editingRegulationBundler: this.editingRegulationBundler,
          regulationItems: this.regulationItems
        }
      })
    },
    async fetchRegulationTemplate () {
      await axios.get(`/api/regulation_bundlers/templates`).then(
        ({ data }) => {
          const deserializedData = deserialize(data).data

          this.regulationTemplateName = deserializedData.name
          this.regulationTemplateItems = deserializedData.templateItems.map(
            (templateItem) => ({
              id: null,
              type: 'regulationItem',
              regulationBundlerId: null,
              order: templateItem.order,
              rules: templateItem.rules,
              variety: templateItem.variety,
              warningText: templateItem.warningText,
              _destroy: false
            })
          )
          this.assignTemplateToEditingRegulation()
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.errors.toString()
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    },
    assignTemplateToEditingRegulation () {
      this.editingRegulationBundler = {
        ...this.editingRegulationBundler,
        name: this.regulationTemplateName
      }
      this.regulationItems = this.regulationTemplateItems.map(
        (templateItem) => ({ ...templateItem })
      )
    },
    async copyRegulationCheck (regulationBundler) {
      this.editingRegulationBundler = Object.assign({}, regulationBundler)
      await this.referRegulationItems()
      this.regulationItems.forEach((item) => {
        item.id = null
        item.regulationBundlerId = null
      })

      this.editingRegulationBundler.id = null
      this.editingRegulationBundler.name += 'のコピー'
      this.$router.push({
        name: 'adminRegulationCheckNew',
        query: {
          editingRegulationBundler: this.editingRegulationBundler,
          regulationItems: this.regulationItems
        }
      })
    },
    deleteRegulationCheck (id) {
      if (
        !confirm(
          `削除したレギュレーションチェックは復元出来ません。本当にID: ${id} のレギュレーションチェックを削除しますか？`
        )
      ) { return true }

      this.$store.dispatch('LoaderStore/displayLoader')
      axios
        .delete(`/api/regulation_bundlers/${id}`)
        .then(
          () => {
            const payload = {
              status: 200,
              message: 'レギュレーションチェックを削除しました'
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
            this.fetchRegulationBundlers()
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.message.toString()
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
        .finally(() => this.$store.dispatch('LoaderStore/hideLoader'))
    }
  }
}
</script>

<style scoped>
th,
td {
  vertical-align: middle;
}
</style>
